import Vue from "vue";
import noty from "./noty.service";

export default {
    async getSettingsAsync(clientId) {
        return (await Vue.http.get(`/api/mascot/settings/${clientId}`)).data;
    },
    async saveSettingsAsync(clientId, settings) {
        await Vue.http.post(`/api/mascot/settings/${clientId}`, settings);
        noty.success("Settings saved successfully");
    }
};


// WEBPACK FOOTER //
// ./src/services/mascot.service.js